import { UsersService } from 'src/app/core/services';
import { AuthenticationService } from './../../../authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Route } from '@angular/compiler/src/core';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {
  public currentUser;
  public isLogin;
  public isFormActive = false;
  public currentForm;
  public currentApplication: any
  public activeParams = '';
  public payment_status: any = '0'
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UsersService,
    private activatedRoute: ActivatedRoute,
    public _TS: ToastrService,
  ) { }

  ngOnInit() {
    this.isLogin = this.authenticationService.isLogin();
    this.authenticationService.getUserInfo().subscribe(data => {
      this.currentUser = data;
    });
    this.currenApplication()
    let currentUrl = this.router.url.split('/');
    this.activatedRoute.queryParams.subscribe(data => {
      this.activeParams = data.type;
    })
    if (currentUrl[1] == 'create-permit') {
      this.isFormActive = true;
    }
  }

  logout() {
    this.authenticationService.logout();
    this.isLogin = false;
    this.router.navigate(['/'])
  }

  saveAndExit() {
    if (this.activeParams == 'reviewForm') {
      this.router.navigate(['/index'])
    } else {
      this.userService.isSaveAndExit.next({ isSaveAndExit: true, currentForm: this.activeParams });;
    }
  }

  goToPayment() {
    this.router.navigate(['/payment'], { queryParams: { id: this.currentApplication.id, fee_type: 0 } });
  }

  currenApplication() {
    // debugger
    this.currentApplication = this.userService.getCurrentApplication();
    if (this.currentApplication && this.currentApplication['payment_status']) {
      this.payment_status = this.currentApplication['payment_status']

    }

  }
  sumitted() {
    // debugger
    const data = {
      application_id: this.currentApplication.id,
      type: this.currentApplication.type
    }
    this.userService.submittedApplication(data).subscribe(data => {
      this._TS.success('Application submitted'),
        this.router.navigate(['/index'])
    })
  }

  Resumitted() {
    const data = {
      application_id: this.currentApplication.id,
     // type: this.currentApplication.type
    }
    this.userService.resubmitedApplication(data).subscribe(data => {
      this._TS.success('Application Re-submitted'),
        this.router.navigate(['/index'])
    })
  }

  exit() {
    this.router.navigate(['/index']);
  }

}
